import { render, staticRenderFns } from "./PaymentMethodItem.vue?vue&type=template&id=1b48cf73&scoped=true&"
import script from "./PaymentMethodItem.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodItem.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodItem.vue?vue&type=style&index=0&id=1b48cf73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48cf73",
  null
  
)

export default component.exports